import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  AssistantFilterItem,
  AssistantFilterPayload,
  AssistantOverlayTypeEnum,
  AssistantStore,
} from '../@store/assistant';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AssistantService {
  constructor(public assistantStore: AssistantStore, private location: Location) {}

  documentsFiltersSelectedInDropdown$: BehaviorSubject<AssistantFilterItem[]> = new BehaviorSubject<
    AssistantFilterItem[]
  >(null);

  filterToBeRemovedById$: Subject<string> = new Subject();

  changeOverlay(overlay: AssistantOverlayTypeEnum): void {
    this.assistantStore.setOverlay(overlay);
  }

  closeOverlay(previousOverlay: AssistantOverlayTypeEnum): void {
    if (previousOverlay === AssistantOverlayTypeEnum.FeedbacksView) {
      this.assistantStore.setOverlay(previousOverlay);
    } else {
      this.assistantStore.closeOverlay();
    }
  }

  public mapFiltersToFilterPayload(filters: AssistantFilterItem[]): AssistantFilterPayload {
    const result: AssistantFilterPayload = {};

    filters.forEach((item) => {
      const attribute = item.value.attribute;
      const conceptId = item.value.concept.id;

      if (!result[attribute]) {
        result[attribute] = [];
      }

      if (!result[attribute].includes(conceptId)) {
        result[attribute].push(conceptId);
      }
    });

    return result;
  }

  public replaceStateWithDocumentIdAndUpdateOverlay(documentId: string): void {
    this.location.replaceState('/assistant/' + documentId);
    this.changeOverlay(AssistantOverlayTypeEnum.DocumentDetailsView);
  }
}
